import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Any damage intentionally caused by you or one of your relatives, by a repair caused by an unqualified person, or by the use of non-compliant or defective equipment, or as a result of a computer virus;',
          'Any repair carried out by a provider other than the one proposed by Shine.',
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          'Remote repair diagnostics, coverage by our provider, and a loan of a laptop equivalent to your request;',
          'Repair, replacement, or reimbursement of your device based on the diagnosis of our partner;',
          'One claim per year per Shine account up to a limit of €3,000, with a €100 deductible in case of damage and 10% of the purchase price in case of theft.',
        ],
        title: 'This coverage includes',
      },
      timeline: {
        items: [
          'A remote diagnosis is carried out.',
          'If your computer is repairable, you can send it to the repairer and get a loaner laptop on request. If the repair takes more than 7 days, you can also request a replacement for your computer.',
          'If your computer is not repairable, we exchange your old computer for a new one with the possibility of recovering your data. A reimbursement is also possible (a deductible and depreciation will be applied).',
        ],
        title: 'How it works',
      },
    },
    similarOffersTitle: 'Other related insurances',
    title: 'Laptop Insurance',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Tout dommage causé intentionnellement par vous ou l’un·e de vos proches, par une réparation causée par une personne non compétente, ou par l’utilisation d’un matériel non conforme ou défectueux, ou suite à un virus informatique ;',
          'Toute réparation effectuée par un autre prestataire que celui proposé par Shine.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          'Le diagnostic des réparations à distance, la prise en charge par notre prestataire et un prêt d’ordinateur portable équivalent à votre demande ;',
          'La réparation, le remplacement ou le remboursement de votre appareil en fonction du diagnostic de notre partenaire ;',
          'Un sinistre par an par compte Shine dans la limite de 3 000 €, avec une franchise de 100 € en cas de dommage et de 10 % du prix d’achat en cas de vol.',
        ],
        title: 'Cette garantie inclut',
      },
      timeline: {
        items: [
          'Un diagnostic à distance est effectué.',
          'Si votre ordinateur est réparable, vous pourrez l’envoyer au réparateur et bénéficier d’un ordinateur de prêt sur demande. Si la réparation prend plus de 7 jours, vous pouvez également demander un remplacement de votre ordinateur.',
          'Si votre ordinateur n’est pas réparable nous échangeons votre ancien ordinateur par un nouveau avec possibilité de récupérer vos données. Un remboursement est également possible (une franchise et une vétusté seront appliquées).',
        ],
        title: 'Comment ça marche',
      },
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Ordinateur Portable',
  },
} as const);

export default locales;
